export default __webpack_public_path__ + "static/media/slider-mobile-shake.b07a2095.jpg";